/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 09 2024
 **/

import { SPACE_SCENE_TYPE } from "@/frameworks/core/commons";

export const initSpaceStateFn = (data: {
	accessAllowType: CreateSpaceStateType["accessAllowType"];
}): CreateSpaceStateType => {
	return {
		groupId: "",
		name: "",
		description: "",
		inviteUserEmails: [],
		allowOtherGroupUser: true,
		allowSearch: true,
		keywords: [],
		spaceThemeId: "default-space-theme-01",
		sceneType: SPACE_SCENE_TYPE.LOBBY,
		...data,
		// *아래 항목들은 frontend에서만 사용되는 항목입니다.
		imageSrc: "",
		maxUserCount: 200,
		useAudioZone: false
	};
};
